export default __webpack_public_path__ + "static/media/Marianopolis-landscape.c032f5ec.jpeg";